
import './methods/browserPopstateHandler'
import './methods/readBrowserUrl'

import preparePageData from './modules/prepareComponentData/preparePageData'
preparePageData()

import CheckoutComplete from './components/CheckoutPage/CheckoutComplete/CheckoutComplete.init'
CheckoutComplete.render()

import CheckoutCartButtons from './components/CheckoutPage/CheckoutCartButtons/CheckoutCartButtons.init'
CheckoutCartButtons.render()

import ProductTile from './components/Frontpage/M04-ProductTileGrid/M04-ProductTile/ProductTile.init'
ProductTile.render()

import ProductTileGrid from './components/Frontpage/M04-ProductTileGrid/ProductTileGrid.init'
ProductTileGrid.render()

import ShopFilterContainer from './components/Frontpage/M02-ShopFilterContainer/ShopFilterContainer.init'
ShopFilterContainer.render()

import PromotionCollections from './components/Frontpage/M15-PromotionCollections/PromotionCollections.init'
PromotionCollections.render()


import ProductInfo from './components/ProductPage/M07-ProductInfo/ProductInfo.init'
ProductInfo.render()

import ProductInfoTablist from './components/ProductPage/M11-ProductInfoTablist/ProductInfoTablist.init'
ProductInfoTablist.render()

import ConfiguratorTablist from './components/ProductPage/M12-ConfiguratorTablist/ConfiguratorTablist.init'
ConfiguratorTablist.render()

import AddedToCartNotification from './components/ProductPage/M17-AddedToCartNotification/AddedToCartNotification.init'
AddedToCartNotification.render()


import CheckoutCart from './components/CheckoutPage/CheckoutCart/CheckoutCart.init'
CheckoutCart.render()

import CheckoutLine from './components/CheckoutPage/CheckoutLine/CheckoutLine.init'
CheckoutLine.render()

import CheckoutBillingInfo from './components/CheckoutPage/CheckoutBillingInfo/CheckoutBillingInfo.init'
CheckoutBillingInfo.render()

import RelatedProductCourse from './components/ProductPage/B01B-RelatedProductCourse/RelatedProductCourse.init'
RelatedProductCourse.render()

import RelatedProduct from './components/ProductPage/B01A-RelatedProduct/RelatedProduct.init'
RelatedProduct.render()




